// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { MaterialImportAiProposal_ReviewFragmentDoc } from '../../material-import/MaterialImportPage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateMaterialListingAiImportMutationVariables = Types.Exact<{
  input: Types.CreateMaterialImportAiProposalInput;
}>;


export type CreateMaterialListingAiImportMutation = { __typename?: 'Mutation', createMaterialImportAiProposal: { __typename?: 'MaterialImportAiProposal', id: string, materialListing?: { __typename?: 'MaterialListing', id: string, aiProposal?: { __typename?: 'MaterialImportAiProposal', id: string, failureReason?: string | null | undefined, progressText?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, manufacturerUrl: string, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, item: { __typename?: 'Item', id: string, name: string }, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }>, entity:
            | { __typename?: 'MaterialListing', id: string }
            | { __typename?: 'MaterialVariant', id: string }
            | { __typename?: 'ReadyPlanLocation' }
            | { __typename?: 'ReadyPlanOption' }
            | { __typename?: 'ReadyPlanProgramData' }
            | { __typename?: 'TakeoffLineItem' }
           }> } | null | undefined } | null | undefined } };

export type ClearMaterialListingAiImportMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ClearMaterialListingAiImportMutation = { __typename?: 'Mutation', clearMaterialImportAiProposal: { __typename?: 'MaterialImportAiProposal', id: string, materialListing?: { __typename?: 'MaterialListing', id: string, aiProposal?: { __typename?: 'MaterialImportAiProposal', id: string } | null | undefined } | null | undefined } };

export type DismissMaterialImportAiProposalMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DismissMaterialImportAiProposalMutation = { __typename?: 'Mutation', dismissMaterialImportAiProposal: { __typename?: 'MaterialImportAiProposal', id: string, materialListing?: { __typename?: 'MaterialListing', id: string, aiProposal?: { __typename?: 'MaterialImportAiProposal', id: string } | null | undefined } | null | undefined } };


export const CreateMaterialListingAiImportDocument = gql`
    mutation CreateMaterialListingAiImport($input: CreateMaterialImportAiProposalInput!) {
  createMaterialImportAiProposal(input: $input) {
    id
    materialListing {
      id
      aiProposal {
        ...MaterialImportAiProposal_Review
      }
    }
  }
}
    ${MaterialImportAiProposal_ReviewFragmentDoc}`;

/**
 * __useCreateMaterialListingAiImportMutation__
 *
 * To run a mutation, you first call `useCreateMaterialListingAiImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterialListingAiImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaterialListingAiImportMutation, { data, loading, error }] = useCreateMaterialListingAiImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMaterialListingAiImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMaterialListingAiImportMutation, CreateMaterialListingAiImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMaterialListingAiImportMutation, CreateMaterialListingAiImportMutationVariables>(CreateMaterialListingAiImportDocument, options);
      }
export type CreateMaterialListingAiImportMutationHookResult = ReturnType<typeof useCreateMaterialListingAiImportMutation>;
export type CreateMaterialListingAiImportMutationResult = ApolloReactCommon.MutationResult<CreateMaterialListingAiImportMutation>;
export const ClearMaterialListingAiImportDocument = gql`
    mutation ClearMaterialListingAiImport($id: ID!) {
  clearMaterialImportAiProposal(id: $id) {
    id
    materialListing {
      id
      aiProposal {
        id
      }
    }
  }
}
    `;

/**
 * __useClearMaterialListingAiImportMutation__
 *
 * To run a mutation, you first call `useClearMaterialListingAiImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearMaterialListingAiImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearMaterialListingAiImportMutation, { data, loading, error }] = useClearMaterialListingAiImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearMaterialListingAiImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearMaterialListingAiImportMutation, ClearMaterialListingAiImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearMaterialListingAiImportMutation, ClearMaterialListingAiImportMutationVariables>(ClearMaterialListingAiImportDocument, options);
      }
export type ClearMaterialListingAiImportMutationHookResult = ReturnType<typeof useClearMaterialListingAiImportMutation>;
export type ClearMaterialListingAiImportMutationResult = ApolloReactCommon.MutationResult<ClearMaterialListingAiImportMutation>;
export const DismissMaterialImportAiProposalDocument = gql`
    mutation DismissMaterialImportAiProposal($id: ID!) {
  dismissMaterialImportAiProposal(id: $id) {
    id
    materialListing {
      id
      aiProposal {
        id
      }
    }
  }
}
    `;

/**
 * __useDismissMaterialImportAiProposalMutation__
 *
 * To run a mutation, you first call `useDismissMaterialImportAiProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissMaterialImportAiProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissMaterialImportAiProposalMutation, { data, loading, error }] = useDismissMaterialImportAiProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissMaterialImportAiProposalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissMaterialImportAiProposalMutation, DismissMaterialImportAiProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DismissMaterialImportAiProposalMutation, DismissMaterialImportAiProposalMutationVariables>(DismissMaterialImportAiProposalDocument, options);
      }
export type DismissMaterialImportAiProposalMutationHookResult = ReturnType<typeof useDismissMaterialImportAiProposalMutation>;
export type DismissMaterialImportAiProposalMutationResult = ApolloReactCommon.MutationResult<DismissMaterialImportAiProposalMutation>;